import React from 'react'

import { useIntl } from '@app/intl/Intl'
import { Page } from '@app/lib/layout/Page/Page'
import { PageContent } from '@app/lib/layout/Page/PageContent'
import { PageHeader } from '@app/lib/layout/Page/PageHeader'
import { Heading } from '@app/lib/typography/Heading/Heading'
import { CourtCasesWidget } from '@app/modules/CourtCasesTables/Components/CourtCasesWidget'
import { NavBar } from '@app/NavBar'

export const CourtCasesTables = () => {
  const { formatMessage } = useIntl()

  return (
    <NavBar title='Gerichtsfälle'>
      <Page>
        <PageHeader>
          <Heading size={'xl'}>{formatMessage({ id: 'CourtCasesTables.Title' })}</Heading>
        </PageHeader>
        <PageContent>
          <CourtCasesWidget />
        </PageContent>
      </Page>
    </NavBar>
  )
}
